import Vue from 'vue'
import Vuex from 'vuex'
import networkManager from './modules/networkManager'
import projects from './modules/projects'
import userProfile from './modules/userProfile'
import cache from './plugins/cache'
import sync from './plugins/sync'
import loadState from '../loadState'
import * as types from './mutation-types'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    initialized: false
  },
  mutations: {
    [types.LOAD_FROM_CACHE](state: any, cached) {
      // do not load if already initialized?
      console.log('loadFromCache entry', state, cached)
      if (cached) {
        console.log('loadFromCache re-populating state from cached data')
        Object.keys(cached).forEach((key) => {
          state[key] = Object.assign({}, state[key], cached[key]);
        });
      }

      state.initialized = true;
      console.log('loadFromCache end', state)
    }
  },
  actions: {
  },
  modules: {
    networkManager,
    projects,
    userProfile
  },
  plugins: [
    cache,
    sync
  ]
})

loadState(store)

export default store
